import { IBoltTaskSOP } from "@bolt/core";
import { FieldLabel, TagsField, fieldTypes } from "@ucl/library";
import classNames from "classnames";
import { FC } from "react";
import { isNil } from "lodash";

export interface SOPComponentProps
  extends fieldTypes.BaseFieldProps<IBoltTaskSOP> {
  showLabel?: boolean;
  showInvalidUrlWarning?: boolean;
}

function isValidURL(url: string) {
  try {
    new URL(url);
    // Additional checks, if necessary.
    return true;
  } catch (error) {
    return false;
  }
}

export const SOPComponent: FC<SOPComponentProps> = ({
  readOnly,
  value,
  onSubmit,
  showLabel = true,
  showInvalidUrlWarning = true,
}) => {
  if (readOnly) {
    return (
      <div
        className={classNames(
          "SOP-field",
          "bp5-form-group",
          "base-field",
          "SOP-disabled"
        )}
      >
        <div className={classNames("bp5-form-content")}>
          {showLabel && <FieldLabel labelName={"SOP"} isRequired={false} />}
          {value && value.sop_AsList && value.sop_AsList.length > 0 ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="16"
              viewBox="0 0 15 16"
              fill="none"
            >
              <path
                d="M1.68533 0.320312C0.778426 0.320312 0.0512695 1.08036 0.0512695 2.02829V13.9841C0.0512695 14.932 0.778426 15.6921 1.68533 15.6921H13.1238C14.0307 15.6921 14.7578 14.932 14.7578 13.9841V2.02829C14.7578 1.08036 14.0307 0.320312 13.1238 0.320312H1.68533ZM1.68533 2.02829H13.1238V13.9841H1.68533V2.02829ZM3.31939 3.73626V5.44424H11.4897V3.73626H3.31939ZM3.31939 7.15222V8.86019H11.4897V7.15222H3.31939ZM3.31939 10.5682V12.2761H9.0386V10.5682H3.31939Z"
                fill="#4D85EB"
              />
            </svg>
          ) : null}
          <ul className={classNames("bp5-input-group", "bp5-read-only")}>
            {value?.sop_AsList &&
              value?.sop_AsList?.map((sop, i) => {
                const isValidUrl = isValidURL(sop);
                if (!isValidUrl) {
                  return showInvalidUrlWarning ? "Invalid URL" : null;
                }

                return (
                  <li key={i}>
                    <a target="_blank" rel="noopener noreferrer" href={sop}>
                      {sop}
                    </a>
                  </li>
                );
              })}
          </ul>
          {isNil(value?.sop_AsList) && (
            <span className="field-only placeholder-text">No SOP</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <TagsField
      label={showLabel ? "SOP" : ""}
      type="Tags"
      fieldName="taskTypeSOP_AsList"
      fieldKey="taskTypeSOP_AsList"
      value={value?.sop_AsList}
      tagsSettings={{}}
      onSubmit={(sop_AsList) =>
        onSubmit && onSubmit({ sop_AsList } as IBoltTaskSOP)
      }
    />
  );
};
